import { Skeleton } from "@/shared/components/ui/skeleton";

// Mirrors the matrix layout: matrices rail, toolbar card, tagline, grid.
export function MatrixLoadingCard() {
  return (
    <div
      className="flex w-full max-w-full flex-1 flex-col gap-0 overflow-hidden contain-size lg:flex-row lg:gap-0"
      aria-busy="true"
      aria-label="Loading matrix"
    >
      <aside className="border-border hidden w-[220px] shrink-0 flex-col gap-3 border-r pt-4 pr-6 pl-2 sm:pt-6 lg:flex xl:w-[240px]">
        <Skeleton className="h-8 w-full rounded-md" />
        <Skeleton className="mt-2 h-3 w-16" />
        <Skeleton className="h-[120px] w-full rounded-xl" />
        <Skeleton className="h-[120px] w-full rounded-xl" />
      </aside>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-4 py-4 sm:py-6 lg:pr-6 lg:pl-6">
        <div className="border-border/80 bg-card rounded-xl border p-4 shadow-sm">
          <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:gap-6">
            <div className="flex items-center gap-3">
              <Skeleton className="size-10 rounded-lg" />
              <Skeleton className="h-6 w-44" />
            </div>
            <Skeleton className="h-10 min-w-0 flex-1 rounded-full" />
            <div className="flex shrink-0 items-center gap-2">
              <Skeleton className="h-8 w-28 rounded-md" />
              <Skeleton className="h-8 w-16 rounded-md" />
            </div>
          </div>
        </div>

        <Skeleton className="h-4 w-64" />

        <div className="border-border/80 bg-background flex min-h-0 flex-col overflow-hidden rounded-xl border shadow-sm">
          <div className="border-border/80 bg-muted/25 flex items-center gap-3 border-b px-3 py-3">
            <Skeleton className="size-4 rounded" />
            <Skeleton className="h-3 w-6" />
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-40" />
            <Skeleton className="ml-auto h-3 w-20" />
          </div>
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={index}
              className={`border-border/80 flex items-center gap-3 px-3 py-3.5 ${index < 3 ? "border-b" : ""}`}
            >
              <Skeleton className="size-4 rounded" />
              <Skeleton className="h-3 w-6" />
              <Skeleton className="h-3 w-40" />
              <Skeleton className="h-3 w-52" />
            </div>
          ))}
          <div className="bg-muted/20 border-border/80 border-t px-3 py-3">
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      </div>
    </div>
  );
}
